import { useEffect, useState } from 'react';
import { type Session } from '@supabase/supabase-js';
import * as Sentry from '@sentry/react';
import { supabase, getOrganisationIdFromUser, getUserRole } from '../lib/supabase';
import type { UserRole } from '../lib/supabase';

export function useAuth() {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
      if (session?.user) {
        Sentry.setUser({ id: session.user.id, email: session.user.email });
      }
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      if (session?.user) {
        Sentry.setUser({ id: session.user.id, email: session.user.email });
      } else {
        Sentry.setUser(null);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  const user = session?.user ?? null;
  const organisationId = getOrganisationIdFromUser(user);
  const role: UserRole = getUserRole(user);

  return {
    session,
    user,
    organisationId,
    role,
    loading,
    isAuthenticated: !!session,
    isEditor: role === 'editor',
  };
}
